import Dexie from "dexie";
import dexieDB from "@/network/db/dexieDb";
import LRUCache from "@/uitls/LRUCache";


let groupList = new Map();
let imlist = new Map();
let imfriendlist = new LRUCache(100);
let imusers = new LRUCache(2000);
let isimlistload = false;

export async function clearServe() {
    groupList.clear();
    imlist.clear();
    imfriendlist.clear();
    imusers.clear();
    isimlistload = false;
}

//创建聊天会话列表
// export async function createImList() { 
//     var db = dexieDB.db;
//     if ((await db.imlist.where({ chatkey: 100 }).count()) === 0) {
//         const id = await db.imlist.add({ chatkey: 100, isGroup: false, uid: 0, content: "测试", msgtype: 1 });

//     } else {
//         const res = await db.imlist.get(100)
//     }
// }

//新增或者更新私聊数据
export async function createChat(data) {
    console.log('dbServe', data);
    const { chatkey, chatmsgno } = data;
    const db = dexieDB.db;
    const message = await getdataImChat(chatkey, chatmsgno);
    if (message) {
        const nextData = {
            ...data,
            read: message.read || data.read,
        };
        delete nextData.id;
        await db.imchat.update(message.id, nextData);
        return message.id;
    }

    const id = await db.imchat.add(data);
    return id;
}

//模糊查询好友列表
export async function getImUserName(name: string) {
    console.log('dbServe', name);
    const db = dexieDB.db;
    const v = await db.imfriend.toArray()
    // console.log(v);
    let list = []
    if (v && v.length > 0) {
        for (let i = 0; i < v.length; i++) {
            const element = v[i];
            if (element.nickname.indexOf(name) != -1) {
                list.push(element)
            }
        }
    }
    return list;
}
//模糊查询会话群组
export async function getImGroupName(str: string) {
    console.log('dbServe', str);
    const db = dexieDB.db;
    const v = await db.imlist.toArray()
    let list = []
    if (v && v.length > 0) {
        for (let i = 0; i < v.length; i++) {
            const element = v[i];
            if (element.isGroup) {
                if (element.nickname.indexOf(str) != -1) {
                    list.push(element)
                }
            }

        }
    }
    return list;
}
//模糊查询聊天内容
export async function getImChatContent(str: string) {
    console.log('dbServe', str);
    const db = dexieDB.db;
    const v = await db.imchat.toArray()
    let list = []
    if (v && v.length > 0) {
        for (let i = 0; i < v.length; i++) {
            const element = v[i];
            if (element.content.indexOf(str) != -1) {
                list.push(element)
            }
        }
    }
    return list;
}

//获取所有聊天
export async function getIMChatAll(chatkey: string, page: number) {
    console.log('dbServe', chatkey);
    const db = dexieDB.db;
    const chatCollection = db.imchat
        .where("[chatkey+chatmsgno]")
        .between([chatkey, Dexie.minKey], [chatkey, Dexie.maxKey]);
    const count = await chatCollection.count();
    if (count == 0) {
        return [];
    }

    const num = count - (page * 20);
    let limit = 20;
    if (num < 1) {
        const itemnum = 1 - num;
        limit = limit - itemnum + 1;
    }
    console.log("getIMChatAll", chatkey, num, limit);
    const val = await chatCollection.offset(num).limit(limit).toArray();
    return val;
}
//获取私聊最后一条消息
export async function getChatLast(chatkey: string) {
    console.log('dbServe', chatkey);
    const db = dexieDB.db;
    const val = await db.imchat
        .where("[chatkey+chatmsgno]")
        .between([chatkey, Dexie.minKey], [chatkey, Dexie.maxKey])
        .last()
    return val;
}
//更新消息
export async function updateImChat(chatkey: string, chatmsgno, content?) {
    console.log('dbServe', chatkey);
    const db = dexieDB.db;
    const val = await db.imchat.get({ chatkey, chatmsgno })
    if (val) {
        if (content) {//带了内容的是自己发的消息返回
            val.content = content;
        } else {//消息已读
            // console.log('更新缓存聊天或已读数据',chatmsgno);
            val.read = true;
        }
        db.imchat.update(val.id, val);
    }
}

export async function updateImMsgRead(chatkey: string, chatmsgno: number[]) {
    console.log('dbServe updateImMsgRead', chatkey, chatmsgno);
    const db = dexieDB.db;
    return await db.imchat.where('chatkey').equals(chatkey)
        .and(it => chatmsgno.includes(it.chatmsgno))
        .modify({ read: true })
}

export async function getUnreadIMChatCount(chatkey: string, myUid: any) {
    const db = dexieDB.db;
    const chatCollection = db.imchat.where('chatkey').equals(chatkey);
    const total = await chatCollection.count();
    if (total === 0) {
        return null;
    }
    const uid = myUid == null ? "" : myUid.toString();
    return await chatCollection
        .and(it => !it.read && (it.uid == null || it.uid.toString() !== uid))
        .count();
}

export async function syncIMListRedWithUnread(chatkey: string, myUid: any) {
    const imItem = await getIMListItem(chatkey);
    if (!imItem) {
        return 0;
    }
    const unreadCount = await getUnreadIMChatCount(chatkey, myUid);
    if (unreadCount === null) {
        return Number(imItem.red || 0);
    }
    if (Number(imItem.red || 0) !== unreadCount) {
        imItem.red = unreadCount;
        await updateIMList(chatkey, imItem);
    }
    return unreadCount;
}

//检查有没有重复消息
export async function getdataImChat(chatkey: string, chatmsgno) {
    console.log('dbServe isRepeatImChat', chatkey);
    const db = dexieDB.db;
    const val = await db.imchat.get({ chatkey, chatmsgno })
    return val;
}

//获取聊天会话
export async function getIMListItem(chatkey: string) {
    let chat = imlist.get(chatkey);
    if (chat) {
        return chat;
    }
    console.log('dbServe getIMListItem', chatkey);
    const db = dexieDB.db;
    const val = await db.imlist.get(chatkey);
    if (val) {
        imlist.set(chatkey, val);
    }
    return val;
}
//删除聊天回话
export async function delImList(key) {
    console.log('dbServe', key);
    imlist.delete(key);
    const db = dexieDB.db;
    const val = await db.imlist.delete(key)
    return val
}

//新建聊天会话
export async function createIMList(data) {
    console.log('dbServe', data);
    imlist.set(data.chatkey.toString(), data);
    const db = dexieDB.db;
    const val = await db.imlist.add(data)
    return val;
}

//获取所有聊天会话
export async function getIMListAll() {
    if (isimlistload) {
        return Array.from(imlist.values());
    }
    console.log('dbServe getIMListAll');
    const db = dexieDB.db;
    const val = await db.imlist.toArray();
    for (let i = 0; i < val.length; i++) {
        imlist.set(val[i].chatkey, val[i]);
    }
    isimlistload = true;
    return val;
}

//更新聊天会话
export async function updateIMList(chatkey: string, data) {
    console.log('dbServe', chatkey);
    imlist.set(chatkey.toString(), data);
    const db = dexieDB.db;
    const val = await db.imlist.update(chatkey, data)
    return val;
}

//检查有没有重复消息会话消息
export async function isRepeatImList(chatkey: string, chatmsgno) {
    console.log('dbServe', chatkey);
    const db = dexieDB.db;
    const val = await db.imlist.get({ chatkey, chatmsgno })
    if (val) {
        return true
    } else {
        return false
    }
}

//获取用户表信息
export async function getImUserByFid(fid: number) {
    for (const item of imusers.cache.values()) {
        if (item.fid == fid) {
            return item;
        }
    }

    const db = dexieDB.db;
    const list = await db.imuser.toArray()
    for (const item of list) {
        if (item.fid == fid) {
            return item;
        }
    }
    return null;
}

//获取用户表信息
export async function getImUser(uid: number) {
    var user = imusers.get(uid);
    if (user) {
        return user;
    }

    console.log('dbServe uid=', uid);
    console.log('dexieDB=', dexieDB);
    console.log('dexieDB.db=', dexieDB.db);

    if (!dexieDB.open || !dexieDB.db) {
        await dexieDB.init();
    }

    var db = dexieDB.db;
    if (!db) {
        console.error('Dexie DB 初始化失败');
        return null;
    }

    var val = await db.imuser.get(uid);
    if (val) {
        imusers.set(uid, val);
    }
    return val || null;
}

//修改用户表信息
export async function updateImUser(uid: number, data: any) {
    console.log('dbServe', uid);
    imusers.set(uid, data);
    const db = dexieDB.db;
    const val = await db.imuser.update(uid, data)
    return val;
}
//新建用户信息
export async function addImUser(data: any) {
    console.log('dbServe', data);
    imusers.set(data.uid, data);
    const db = dexieDB.db;
    const val = await db.imuser.add(data)
    return val;
}

//获取所有好友
export async function getIMFriend() {
    console.log('dbServe');
    const db = dexieDB.db;
    const val = await db.imfriend.toArray();
    for (let i = 0; i < val.length; i++) {
        imfriendlist.set(val[i].uid, val[i]);
    }
    return val;
}

//获取好友
export async function getImfriendItem(uid: number) {
    let u = imfriendlist.get(uid);
    if (u) {
        return u;
    }
    console.log('dbServe', uid);
    const db = dexieDB.db;
    const val = await db.imfriend.get(uid);
    if (val) {
        imfriendlist.set(uid, val);
    }
    return val;
}

//修改好友
export async function updateImfriendItem(uid: number, data) {
    console.log('dbServe', data);
    const db = dexieDB.db;
    imfriendlist.set(uid, data);
    const val = await db.imfriend.update(uid, data);
    return val;
}

//新增好友
export async function addImfriend(data) {
    console.log('dbServe', data);
    const db = dexieDB.db;
    imfriendlist.set(data.uid, data);
    const val = await db.imfriend.add(data)
    return val;
}


// 获取所有群聊
export async function getIMGrouplist() {
    console.log('dbServe');
    const val = await dexieDB.db.imgroup.toArray();
    for (let i = 0; i < val.length; i++) {
        groupList.set(val[i].groupkey, val[i]);
    }
    return val;
}

// 获取群聊
export async function getImGroupItem(groupkey) {
    if (!groupkey) {
        return null;
    }
    groupkey = groupkey.toString();
    let group = groupList.get(groupkey);
    if (group) {
        return group;
    }
    console.log('dbServe getImGroupItem', groupkey);
    const val = await dexieDB.db.imgroup.get(groupkey);
    if (val) {
        groupList.set(groupkey, val);
    }
    return val;
}

// 修改群聊
export async function updateImGroupItem(groupkey, data) {
    console.log('dbServe updateImGroupItem', groupkey);
    groupkey = groupkey.toString();
    groupList.set(groupkey, data);
    const val = await dexieDB.db.imgroup.update(groupkey, data);
    return val;
}

// 删除群聊
export async function deleteImGroupItem(groupkey) {
    console.log('dbServe', groupkey);
    groupkey = groupkey.toString();
    groupList.delete(groupkey);
    let count = 0;
    await dexieDB.db.imgroup
        .where("groupkey")
        .equals(groupkey)
        .delete()
        .then(function (deleteCount) {
            count = deleteCount;
        });
    return count;
}

// 新增群聊
export async function addImGroup(data) {
    console.log("dbServe", data);
    let groupkey = data.groupkey.toString();
    groupList.set(groupkey, data);
    const val = await dexieDB.db.imgroup.add(data);
    return val;
}
